import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthenticationPromptType } from '../models/credentials';

type PromptTypeState = {
  type?: AuthenticationPromptType;
};

const initialState: PromptTypeState = {
  type: undefined,
};

export const promptTypeSlice = createSlice({
  name: 'prompt-type',
  initialState,
  reducers: {
    setPromptType: (state, action: PayloadAction<AuthenticationPromptType>) => {
      state.type = action.payload;
    },
  },
});

export const { setPromptType } = promptTypeSlice.actions;
